/* eslint-disable */
import { useState } from "react"
import { Button, NotificationHub, FormRadioCheckboxButton, DataArray, Box, Link, Alert } from "@nef/core"
import { useWizard } from "react-use-wizard"
import { useFormContext, Controller } from "react-hook-form"

import { NFN_OPS_EMAIL_HREF } from "../../../../../constants/common"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../../../../../app/store"
import { createOrganizationStage, submitOrganizationStagesByOrgId } from "../../../../../redux/organizationStages/actions"
import StyledReviewAndSubmit from "../../../../../styles/ReviewAndSubmit.styles"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"

const ReviewAndSubmit = (props: any) => {
  const { previousStep } = useWizard()
  const { handleSubmit, getValues, control, watch } = useFormContext()
  const [errorMessage, setErrorMessage] = useState("")
  const dispatch = useDispatch<AppDispatch>()

  const { executeRecaptcha } = useGoogleReCaptcha()

  const onSubmit = async (data: any) => {
    // get the ReCAPTCHA token
    // @ts-ignore
    const token = await executeRecaptcha()
    if (!token) NotificationHub.send("danger", "Please complete the reCAPTCHA")
    const payload = {
      payload: {
        signatoryFirstName: data.firstName,
        signatoryLastName: data.lastName,
        signatoryTitle: data.title,
        signatoryEmail: data.email,
        organizationName: data.organizationName,
        mpid: parseMPID(data.isMPID),
        mpidRequested: data.isPricingAgent && !data.isMPID,
        countryOfOperation: {
          regions: [],
          selectedRegion: {
            name: data?.region?.name,
            code: data?.region?.code
          },
          code3CountryLetterIso3166: data.country.code
        }
      },
      params: {
        recaptchaResponse: token
      }
    }
    try {
      const response = await dispatch(createOrganizationStage(payload)).unwrap()
      NotificationHub.send("success", "Organization Created!")
      if (data.issuers !== undefined && data.issuers?.length > 0) {
        submitIssuerStages(data.issuers, response?.organizationStageId)
      }
    } catch (error: any) {
      NotificationHub.send("danger", `${error.status} ${error.message} ${JSON.stringify(error.errors)}`,)
    }
  }

  const submitIssuerStages = async (issuers: string[], stageOrgId: any) => {
    const payload: any[] = []
    issuers.forEach((_issuer: any) => {
      const data: any = {
        organizationStageId: stageOrgId,
        firstCreatedDate: new Date(),
        firstCreatedBy: getValues("email"),
        issuerName: _issuer?.issuerName
      }
      if (_issuer.identifier?.length === 12) {
        data.isin = _issuer.identifier
      } else if (_issuer.identifier?.length === 9) {
        data.cusip = _issuer.identifier
      } else {
        data.cusip = ""
        data.isin = ""
      }
      payload.push(data)
    })
    try {
      const response = await dispatch(submitOrganizationStagesByOrgId({ organizationStageId: stageOrgId, payload })).unwrap()
      if (response?.length) {
        NotificationHub.send("success", "Issuers created!")
      }
    } catch (err: any) {
      const errormsg = err?.error?.errors;
      if (errormsg) {
        setErrorMessage(convertErrors(errormsg))
        NotificationHub.send("danger", "Issuer creation failed!")
        return;
      }
      if (err?.error) {
        NotificationHub.send("danger", `${err?.error}`)
        return;
      }
    }
  }

  function convertErrors(errorObject: any) {
    let errMsg = ""
    for (const [key, value] of Object.entries(errorObject)) {
      const position = key[1] // Extracts the position from the key
      errMsg += `For issuer ${+position + 1}: ${(value as string)[0]}\n`
    }
    return errMsg
  }

  const submissionDeniedAlert = () => {
    const alertRules: boolean[] = watch(["isPricingAgent", "isFundIssuer"])

    if (!alertRules[0] && !alertRules[1]) {
      return (
        <Alert color="warning">
          {" "}
          <p>
            This application cannot be submited as you neither a Pricing Agent nor a Fund Issuer. Please contact{" "}
            <a href={NFN_OPS_EMAIL_HREF}>NFN Operations</a>.
          </p>{" "}
        </Alert>
      )
    }
    return ""
  }

  const onSubmitError = (errors: any) => {
    const { setValidationModalOpen } = props
    setValidationModalOpen(true)
    console.info("Form errors: ", errors)
  }

  const parseMPID = (mpid: boolean) => {
    if (mpid === true) {
      return getValues("MPID")
    }
    return ""
  }

  const isSubmitDisabled = () => {
    const submitRules: boolean[] = watch(["terms", "isPricingAgent", "isFundIssuer"])
    return !(submitRules[0] && (submitRules[1] || submitRules[2]))
  }

  return (
    <>
      <StyledReviewAndSubmit className="review-and-submit">
        <div className="review-and-submit-container">
          <DataArray
            data={[
              { label: "Firstname: ", value: getValues("firstName") },
              { label: "Lastname: ", value: <>{getValues("lastName")}</> },
              { label: "Title: ", value: <>{getValues("title")}</> },
              { label: "Email: ", value: <>{getValues("email")}</> },
              {
                label: "Organization Name: ",
                value: <>{getValues("organizationName")}</>
              },
              {
                label: "Country Name: ",
                value: <>{getValues("country")?.name}</>
              },
              {
                label: "Region Name: ",
                value: <>{getValues("region")?.name || "N/A"}</>
              },
              {
                label: "MPID: ",
                value: <>{parseMPID(getValues("isMPID"))}</>
              },
              {
                label: "Affiliates: ",
                value: (
                  <ul className="no-bullets">
                    {getValues("issuers")?.map((issuer: any) => {
                      return <li key={issuer}>{issuer?.issuerName}</li>
                    })}
                  </ul>
                )
              }
            ]}
          />
          <br />
          {submissionDeniedAlert()}
          <br />
          <Controller
            name="terms"
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <Box className="terms-and-conditions" style={{ display: "flex", margin: "auto" }}>
                  <FormRadioCheckboxButton
                    id="terms"
                    className="terms"
                    name="terms"
                    type="checkbox"
                    label=""
                    checked={value}
                    inline={true}
                    onChange={(e) => {
                      onChange(e.checked)
                    }}
                  />
                  <span>
                    I accept the &nbsp;
                    <Link target="_blank" href="http://www.nasdaqtrader.com/content/administrationsupport/agreementsdata/NFNTermsConditions.pdf">
                      Terms & Conditions
                    </Link>
                  </span>
                </Box>
              </>
            )}
          />
          {errorMessage && (
            <div className="add-issuer__error-msg">
              {errorMessage.split("\n").map((line) => (
                <span key={line}>
                  {line}
                  <br />
                </span>
              ))}
            </div>
          )}
          <div className="action-buttons">
            <Button size="lg" style={{ margin: "auto" }} onClick={() => previousStep()}>
              Back
            </Button>
            <Button
              id="b"
              size="lg"
              type="submit"
              color="primary"
              outline={true}
              style={{ margin: "auto" }}
              disabled={isSubmitDisabled()}
              onClick={handleSubmit(onSubmit, onSubmitError)}
            >
              Submit
            </Button>
            <div id="recaptchav3" />
          </div>
        </div>
      </StyledReviewAndSubmit>
      <NotificationHub {...props} />
    </>
  )
}
export default ReviewAndSubmit
